import React, { Component } from 'react'
import styles from "./SettingBar.module.css"

import firebaseFunc from "../FirebaseService/FirebaseFunc";
export default class SettingBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: null
        }
    }

    signInOutHandler = (e) => {
        if (this.state.user) {
            firebaseFunc.logOut()
        } else {
            // console.log(this.props.logInPath)
            window.location.href = this.props.logInPath
        }
    }

    componentDidMount() {
        firebaseFunc.getStateChange((user) => {
            console.log(user)
            this.setState(state => { return { user: user } })
        })
    }
    render() {

        const SignInStatus = (this.state.user) ? "Sign Out" : "Sign In"
        return (
            <div className={styles.container}>
                <div className={styles.itemStyle} onClick={this.signInOutHandler}>{SignInStatus}</div>
                <hr />
                <div className={styles.itemStyle}>Setting</div>
                <hr />
                <div className={styles.itemStyle}>Load wallpaper</div>
            </div>
        )
    }
}
